"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaOperationToJSON = exports.RosettaOperationFromJSONTyped = exports.RosettaOperationFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaOperationFromJSON(json) {
    return RosettaOperationFromJSONTyped(json, false);
}
exports.RosettaOperationFromJSON = RosettaOperationFromJSON;
function RosettaOperationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'operation_identifier': _1.RosettaOperationIdentifierFromJSON(json['operation_identifier']),
        'related_operations': !runtime_1.exists(json, 'related_operations') ? undefined : (json['related_operations'].map(_1.RosettaRelatedOperationFromJSON)),
        'type': json['type'],
        'status': !runtime_1.exists(json, 'status') ? undefined : json['status'],
        'account': !runtime_1.exists(json, 'account') ? undefined : _1.RosettaAccountFromJSON(json['account']),
        'amount': !runtime_1.exists(json, 'amount') ? undefined : _1.RosettaAmountFromJSON(json['amount']),
        'coin_change': !runtime_1.exists(json, 'coin_change') ? undefined : _1.RosettaCoinChangeFromJSON(json['coin_change']),
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : json['metadata'],
    };
}
exports.RosettaOperationFromJSONTyped = RosettaOperationFromJSONTyped;
function RosettaOperationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'operation_identifier': _1.RosettaOperationIdentifierToJSON(value.operation_identifier),
        'related_operations': value.related_operations === undefined ? undefined : (value.related_operations.map(_1.RosettaRelatedOperationToJSON)),
        'type': value.type,
        'status': value.status,
        'account': _1.RosettaAccountToJSON(value.account),
        'amount': _1.RosettaAmountToJSON(value.amount),
        'coin_change': _1.RosettaCoinChangeToJSON(value.coin_change),
        'metadata': value.metadata,
    };
}
exports.RosettaOperationToJSON = RosettaOperationToJSON;
//# sourceMappingURL=RosettaOperation.js.map